<template>
  <success-page-layout
    class="bg-transparent"
    hide-continue-browser
    web-to-mobile-flag="spaceInviteAccepted"
    custom-background-color="bg-summer-yellow-6"
    store-badges-button-code="body-20210304-success-page-join-space"
    :promote-app-download="!hasMobileApp || isDesktop"
  >
    <template v-slot:content>
      <div>
        <b-headline type="h1" typography="h2" class="inline" v-html="headline" />
        <span class="text-blue text-h3 m:text-h2 italic inline ml-2">
          {{ spaceName }}
        </span>
      </div>

      <p class="mt-6" v-html="$t('copy')" />
    </template>

    <template v-slot:image>
      <people-spider-image />
    </template>
  </success-page-layout>
</template>

<script>
import { mapGetters } from "vuex"
import { getSearchParam } from "@/utils/location"
import BHeadline from "@/component-library/b-headline"
import SuccessPageLayout from "@/pages/success-page/components/success-page-layout"
import platform from "@/modules/visitor-platform"
import PeopleSpiderImage from "@/pages/spaces/join-page/components/people-spider-image"
// eslint-disable-next-line no-undef
const confetti = require("canvas-confetti")

const MAX_SPACE_NAME_LENGTH = 50

// spaceName comes from a query param and is rendered as the page's main
// message. It is attacker-controllable, so constrain it to a short, single
// line, link-free label to stop it being used to deliver fake "official"
// directives (HackerOne #3783919). It is shown via {{ }} (HTML-escaped), so
// there is no XSS vector here; this only addresses content/phishing injection.
const sanitizeSpaceName = (value) =>
  (value || "")
    .replace(/https?:\/\/\S+/gi, "")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, MAX_SPACE_NAME_LENGTH)

export default {
  name: "JoinSpaceSuccess",
  components: {
    PeopleSpiderImage,
    BHeadline,
    SuccessPageLayout
  },
  computed: {
    ...mapGetters(["hasMobileApp"]),
    spaceName() {
      return sanitizeSpaceName(getSearchParam("spaceName"))
    },
    headline() {
      // Rendered via v-html, so keep spaceName out of it: the message has no
      // spaceName placeholder, and passing one would risk injecting the
      // attacker-controlled value into HTML unescaped if a translation ever
      // added a placeholder. spaceName is shown only via {{ }} (escaped).
      return this.$t("headline")
    },
    isDesktop() {
      return platform.isDesktop()
    }
  },
  mounted() {
    this.showConfetti()
  },
  methods: {
    showConfetti() {
      const confettiCanvas = document.createElement("canvas")
      confettiCanvas.style.cssText = "position: absolute; z-index: 1000000; left: 0; width: 100%; height: 100vh"
      document.body.appendChild(confettiCanvas)
      const myConfetti = confetti.create(confettiCanvas, {
        resize: true,
        useWorker: true
      })
      myConfetti({
        particleCount: 250,
        spread: 150
      })
      setTimeout(() => {
        myConfetti.reset()
        confettiCanvas.remove()
      }, 4000)
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "Great!<br>You are now part of Space:",
        copy: "Download the app, so you can enter your new Space and enjoy Aha-moments together."
      },
      de: {
        headline: "Super!<br>Du bist jetzt Mitglied im Space:",
        copy: "Hol dir die Blinkist App, um den Space zu entdecken und Aha-Momente zu teilen"
      }
    }
  }
}
</script>
